export function isObjectWithKey(
  data: unknown,
): data is { [key: string]: unknown } {
  return typeof data === 'object' && data !== null;
}
